import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import App from './components/App';
import preloadImage from './preloadImage';
import reducer from './reducers';
import thunk from 'redux-thunk';


const store = createStore(reducer, applyMiddleware(thunk));
export default store;
store.dispatch(preloadImage());
// store.subscribe(() => {
//     console.log('subscribe', store.getState());
// });

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root'));

